var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6667 3.66817C15.6667 3.66768 15.6667 3.66719 15.6667 3.66671C15.6667 3.66666 15.6667 3.66661 15.6667 3.66656L17.2292 1.98064C17.4839 1.70583 17.2548 1.26307 16.8834 1.31219L14.9257 1.57111C14.3146 0.816091 13.3804 0.333374 12.3334 0.333374C10.4924 0.333374 9.00004 1.82576 9.00004 3.66671C9.00004 4.10624 9.08511 4.52591 9.23968 4.91014C6.74269 4.85175 4.06912 4.35765 2.71742 1.67954C2.55016 1.34815 2.07066 1.32895 1.96418 1.68457C0.98607 4.95124 2.70742 9.19562 6.49986 10.3334C5.55379 11.2584 3.12181 11.5096 1.13163 11.3273C0.744351 11.2918 0.501222 11.733 0.800709 11.9811C2.46948 13.3635 4.78396 13.6667 6.91659 13.6667C12.3327 13.6667 16.0825 9.08419 15.6667 3.66817Z",
    fill: "rgb(var(--gray))"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5d1cff79f6a2365c0da322386e269cf6.svg";
export { ForwardRef as ReactComponent };